import { Divider as HeroUIDivider } from '@heroui/react';

// Full-width section separator for the Account page, matching the divider pattern in
// ProjectSubmissionForm (a HeroUI Divider between sections). The negative margins bleed the line
// past the `edit-account` container's horizontal padding (px-4 / sm:px-10) so it spans the full
// panel width, and `w-auto` overrides HeroUI's default `w-full` so the bleed can take effect. Each
// section supplies its own vertical padding, so the divider lands centered in the gap between them.
export function Divider() {
    return <HeroUIDivider className="-mx-4 w-auto sm:-mx-10" />;
}
